import React, { FC, useRef } from "react";
import type { PlatformFintechAppsProps } from "@/types";
import { ContentManager } from "../content-manager";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";

export const PlatformFintechApps: FC<PlatformFintechAppsProps> = ({
  content,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section ref={ref} className="platformFintechApps">
      <SplitTextAnimation
        htmlElement={
          <ContentManager
            content={content}
            className="platformFintechApps--content"
          />
        }
        isInView={isInView}
      />
    </section>
  );
};
